import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { getCurrentMQQ, getCurrentWindow } from "../utils/window";
import ua from '@tencent/docs-user-agent';
var isTencentDocsApp = ua.isTencentDocsApp,
    isQQ = ua.isQQ,
    isWindows = ua.isWindows;

function isNtQQ() {
  var _global, _global2;

  return ((_global = global) === null || _global === void 0 ? void 0 : _global.ntqq) || ((_global2 = global) === null || _global2 === void 0 ? void 0 : _global2.ntQQApi);
} // 检查两个URL是否同源


function isSameOrigin(currentUrl, targetUrl) {
  var current = new URL(currentUrl);
  var target = new URL(targetUrl);
  return current.protocol === target.protocol && current.host === target.host;
}
/**
 * qq或者文档app中的打开文件处理
 */


export function doOpenUrlForQQorDocApp(targetUrl, options) {
  var replace = options.replace,
      style = options.style,
      useNewConfig = options.useNewConfig,
      supportIFrame = options.supportIFrame,
      appOption = options.appOption;
  var mqq = getCurrentMQQ(supportIFrame);
  var currentWindow = getCurrentWindow(supportIFrame);
  var openStyle = style || 2; // --bug=105655785 【DL】【文档管理】【探索性测试】qq腾讯文档助手点击后显示空白页，额外打开的网页显示的通知列表也显示空白

  if (!replace && isWindows && isQQ && !isNtQQ()) {
    currentWindow.open(targetUrl);
    return;
  }

  if (replace && !isNtQQ() || !mqq) {
    doReplaceOpen(targetUrl, supportIFrame);
    return;
  } // 有mqq的情况下


  mqq === null || mqq === void 0 ? void 0 : mqq.invoke('ui', 'openUrl', _objectSpread(_objectSpread({}, appOption), {}, {
    url: targetUrl,
    target: 1,
    style: openStyle,
    useQQBrowser: true,
    useNewConfig: useNewConfig
  }), function () {});
}
/**
 * 文档中的replace 处理
 */

function doReplaceOpen(targetUrl, supportIFrame) {
  var currentWindow = getCurrentWindow(supportIFrame);

  if (isTencentDocsApp && isSameOrigin(currentWindow.location.href, targetUrl)) {
    // 跳转后不留history
    currentWindow.history.replaceState(null, document.title, targetUrl);
    currentWindow.location.replace('');
  } else {
    currentWindow.location.replace(targetUrl);
  }
}